// DEPRECATED: This file is no longer used since we switched to HTTP-only cookies
// Authentication is now handled automatically through cookies in axios instances
// Use AuthContext for authentication state and API services for requests

// Legacy functions - DO NOT USE
export const getAuthHeader = () => {
  // HTTP-only cookies are sent automatically - no manual headers needed
  return {};
};

export const isAuthenticated = () => {
  // Use AuthContext instead
  console.warn('utils/auth.js is deprecated. Use AuthContext for authentication.');
  return false;
};

export const isAdminAuthenticated = () => {
  // Use admin services instead
  console.warn('utils/auth.js is deprecated. Use admin services for authentication.');
  return false;
}; 